@if (isShown) {
    <mat-spinner [strokeWidth]="strokeWidth" color="primary" [diameter]="diameter"></mat-spinner>
}
